import { createTheme } from '@mui/material/styles';

const delightPurple = '#7A3BC1';
const delightPurpleDark = '#5A2A8E';
const delightPurpleLight = '#C2A6EA';
const mintAccent = '#2DD4BF';
const slateGrey = '#1F2933';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: delightPurple,
      light: delightPurpleLight,
      dark: delightPurpleDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: mintAccent,
      contrastText: '#0F172A',
    },
    background: {
      default: '#F6F7FB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1F36',
      secondary: '#4A5568',
    },
    divider: '#E4E6EF',
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.4px',
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: '1px solid rgba(122, 59, 193, 0.06)',
          boxShadow: '0 6px 18px rgba(15, 23, 42, 0.06)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: 'linear-gradient(180deg, #FBFAFF 0%, #F1F3FF 100%)',
          borderRight: '1px solid rgba(122, 59, 193, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          color: slateGrey,
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          boxShadow: '0 18px 30px -15px rgba(122, 59, 193, 0.55)',
        },
        containedSecondary: {
          color: '#0F172A',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 10,
          fontSize: 12,
        },
      },
    },
  },
});

export default theme;
